package kz.dentalcrm.app.data.network.response_model.positions

import androidx.compose.runtime.Immutable
import kotlinx.serialization.Serializable

@Serializable
@Immutable
data class Position(
    val id: Int,
    val name: String? = null,
    val description: String? = null,
    val created_at: String? = null,
    val updated_at: String? = null,
    val organization_id: Int? = null
)
